import { NgModule } from '@angular/core';
import { provideConfig, provideConfigFactory } from '@spartacus/core';
import { customIconsConfig } from './icons.config';
import { customLayoutConfig } from './layout.config';
import { customRoutingConfig } from './routes.config';
import { customSiteContextConfig } from './site-context.config';
import { customViewConfig } from './view.config';
import { customOccConfig } from './occ.config';
import {
  ENVIRONMENT_CONFIG,
  EnvironmentConfiguration,
} from '../../../environments/models/environment.model';
import { i18nOverwrites } from './i18n.config';
import { customCartConfig } from './cart.config';

@NgModule({
  providers: [
    // provideConfig(customIconsConfig),
    provideConfig(customLayoutConfig),
    provideConfig(customRoutingConfig),
    provideConfig(customViewConfig),
    provideConfig(customCartConfig),
    provideConfigFactory(
      (env: EnvironmentConfiguration) => customOccConfig(env),
      [ENVIRONMENT_CONFIG],
    ),
    provideConfigFactory(
      (env: EnvironmentConfiguration) => customSiteContextConfig(env),
      [ENVIRONMENT_CONFIG],
    ),
    // provideConfig(customTranslations),
    provideConfig(i18nOverwrites),
  ],
})
export class CustomConfigModule {}
